export default "__VITE_ASSET__BEkGFcXp__"